module.exports = __webpack_public_path__ + "img/Payments.9093a42b.svg";